module.exports = __webpack_public_path__ + "assets/img/poster-3.20499d46.png";